var map = {
	"./avalanche-1-color.svg": 66358,
	"./avalanche-1-greyscale.svg": 90746,
	"./avalanche-2-color.svg": 84142,
	"./avalanche-2-greyscale.svg": 61102,
	"./avalanche-3-color.svg": 95012,
	"./avalanche-3-greyscale.svg": 48650,
	"./avalanche-4-color.svg": 56580,
	"./avalanche-4-greyscale.svg": 33191,
	"./avalanche-5-color.svg": 61195,
	"./avalanche-5-greyscale.svg": 41268
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62510;